import { KeyValue } from '@/main/models/common';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse'; // Mantenha, mas não para getDetailHistoric
import {
  ReportTemplateFilterRequest,
  ReportTemplateRequest,
  ReportTemplateDomainRequest
} from '@/main/models/request';
// Garanta que GetDetailHistoricResponse e ReportTemplateGridResponse são importados corretamente
import {
  GetDetailHistoricResponse,
  ReportTemplateGridResponse,
  ReportTemplateResponse
} from '@/main/models/response';
import { AxiosResponse } from 'axios';

export abstract class IReportTemplateApi {
  abstract getReportTemplateGrid(
    request: ReportTemplateFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<ReportTemplateGridResponse>>>;

  abstract getDocVariables(
    file: File
  ): Promise<AxiosResponse<Result<string[]>>>;

  abstract getReportVariableTypeDomain(): Promise<
    AxiosResponse<Result<KeyValue[]>>
  >;

  abstract save(
    request: ReportTemplateRequest,
    formFile: File
  ): Promise<AxiosResponse<Result<string>>>;

  abstract getReportTemplate(
    guidTemplate: string
  ): Promise<AxiosResponse<Result<ReportTemplateResponse>>>;

  abstract getDomain(
    request: ReportTemplateDomainRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
